import moment from 'moment'

const ruleMatcher = (value, rule) => {
  const { eq, lt, lte, gt, gte } = rule
  let result = []
  if (eq) {
    result.push(value === eq)
  }
  if (lt) {
    result.push(value < lt)
  }
  if (lte) {
    result.push(value <= lte)
  }
  if (gt) {
    result.push(value > gt)
  }
  if (gte) {
    result.push(value >= gte)
  }
  return !result.includes(false)
}

export const getSemaphoreConfigColor = (value, rules) => {
  if (!rules || !value) return null
  const dateA = moment(value)
  const dateB = moment()
  const diff = Math.abs(dateA.diff(dateB, 'minutes'))
  const ruleFound = rules.find(rule => ruleMatcher(diff, rule))
  if (ruleFound) return ruleFound.color
  return null
}
